import React, { useState, useEffect } from "react";
import { Stack, Box } from "@mui/material";
import FormattedTabs from "../../../components/generic/formattedTabs";
import GeneralLedgerRules from "./generalLedgerRules";
import GeneralLedgerAccounts from "./generalLedgerAccounts";
import { backendGetRequest } from "../../../helpers/callBackend";
import OuterBox from "../../../components/generic/arpariBoxes/OuterBox";


const GeneralLedger = () => {
    const [loadingGeneralLedgerAccount, setLoadingGeneralLedgerAccount] = useState(true);
    const [loadingGeneralLedgerHeader, setLoadingGeneralLedgerHeader] = useState(true);
    const [generalLedgerHeaderRecordsCount, setGeneralLedgerHeaderRecordsCount] = useState(-1);
    const [generalLedgerAccountRecordsCount, setGeneralLedgerAccountRecordsCount] = useState(-1);
    const [generalLedgerHeader, setGeneralLedgerHeader] = useState([]);
    const [generalLedgerAccount, setGeneralLedgerAccount] = useState([]);

    useEffect(() => {
        document.title = "Arpari | General Ledger"
        const fetchGeneralLedgerAccounts = async () => {
            try {
                const res = await backendGetRequest("/api/general-ledger/account", { params: { 'page_index': 0 } });
                setGeneralLedgerAccountRecordsCount(res?.data?.total_records);
                if (res?.data?.total_pages < 1) {
                    setLoadingGeneralLedgerAccount(false);
                }
                for (let i = 1; i <= res?.data?.total_pages; i++) {
                    try {
                        const resPage = await backendGetRequest("/api/general-ledger/account", { params: { 'page_index': i } });
                        if (resPage?.data) {
                            setGeneralLedgerAccount(prevData => [...prevData, ...resPage?.data?.general_ledger_account]);
                        }
                    } catch (error) {
                        console.error(`Error fetching page ${i}:`, error);
                    }
                }
                setLoadingGeneralLedgerAccount(false);
            } catch (error) {
                console.error('Error fetching general ledger accounts:', error);
            }
        };

        const fetchGeneralLedgerHeaders = async () => {
            try {
                const res = await backendGetRequest("/api/general-ledger/header", { params: { 'page_index': 0 } });
                setGeneralLedgerHeaderRecordsCount(res?.data?.total_records);
                if (res?.data?.total_pages < 1) {
                    setLoadingGeneralLedgerHeader(false);
                }
                for (let i = 1; i <= res?.data?.total_pages; i++) {
                    try {
                        const resPage = await backendGetRequest("/api/general-ledger/header", { params: { 'page_index': i } });
                        if (resPage?.data) {
                            setGeneralLedgerHeader(prevData => [...prevData, ...resPage?.data?.general_ledger_header]);
                        }
                    } catch (error) {
                        console.error(`Error fetching page ${i}:`, error);
                    }
                }
                setLoadingGeneralLedgerHeader(false);
            } catch (error) {
                console.error('Error fetching general ledger headers:', error);
            }
        };

        fetchGeneralLedgerAccounts();
        fetchGeneralLedgerHeaders();
    }, []);

    return (
        <OuterBox>
            <FormattedTabs
                defaultActiveKey={0}
                tabPanes={[
                    {
                        "title": "Rules",
                        "key": 0,
                        "body": <GeneralLedgerRules
                            loadingGeneralLedgerAccount={loadingGeneralLedgerAccount}
                            loadingGeneralLedgerHeader={loadingGeneralLedgerHeader}
                            generalLedgerHeaderRecordsCount={generalLedgerHeaderRecordsCount}
                            generalLedgerAccountRecordsCount={generalLedgerAccountRecordsCount}
                            generalLedgerHeader={generalLedgerHeader}
                            generalLedgerAccount={generalLedgerAccount}
                            setGeneralLedgerAccount={setGeneralLedgerAccount}
                            setGeneralLedgerHeader={setGeneralLedgerHeader}
                        />
                    },
                    {
                        "title": "Accounts",
                        "key": 1,
                        "body": <GeneralLedgerAccounts
                            loadingGeneralLedgerAccount={loadingGeneralLedgerAccount}
                            loadingGeneralLedgerHeader={loadingGeneralLedgerHeader}
                            generalLedgerHeaderRecordsCount={generalLedgerHeaderRecordsCount}
                            generalLedgerAccountRecordsCount={generalLedgerAccountRecordsCount}
                            generalLedgerHeader={generalLedgerHeader}
                            generalLedgerAccount={generalLedgerAccount}
                            setGeneralLedgerAccount={setGeneralLedgerAccount}
                            setGeneralLedgerHeader={setGeneralLedgerHeader}
                        />
                    }
                ]}
            />
        </OuterBox>
    );
};

export default GeneralLedger;
